var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./InventoryProductStatusLine.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-0fcf40ee!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./InventoryProductStatusLine.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/inventory/InventoryProductStatusLine.vue
// module id = 467
// module chunks = 1